export default defineNuxtPlugin({
  setup() {
    const impersonation = useImpersonation()

    const bff = $fetch.create({
      baseURL: '/api/bff',
      headers: {
        'Content-Type': 'application/json'
      },
      onRequest({ options }) {
        const headers = new Headers(options.headers as HeadersInit)

        // Add impersonation header when admin is impersonating a customer
        // Admin auth is handled server-side via httpOnly cookie
        if (impersonation.isImpersonating.value && impersonation.impersonatedCustomer.value.customerId) {
          headers.set('X-Impersonation-Id', impersonation.impersonatedCustomer.value.customerId)
        }

        options.headers = headers
      }
    })

    return {
      provide: {
        bff
      }
    }
  }
})
